export const PROCESSING_JOB_LIST_REQUEST = 'PROCESSING_JOB_LIST_REQUEST';
export const PROCESSING_JOB_LIST_SUCCESS = 'PROCESSING_JOB_LIST_SUCCESS';
export const PROCESSING_JOB_LIST_FAIL = 'PROCESSING_JOB_LIST_FAIL';

export const PROCESSING_JOB_LIST_BY_IDS_REQUEST = 'PROCESSING_JOB_LIST_BY_IDS_REQUEST';
export const PROCESSING_JOB_LIST_BY_IDS_SUCCESS = 'PROCESSING_JOB_LIST_BY_IDS_SUCCESS';
export const PROCESSING_JOB_LIST_BY_IDS_FAIL = 'PROCESSING_JOB_LIST_BY_IDS_FAIL';

export const PROCESSING_JOB_DETAILS_REQUEST = 'PROCESSING_JOB_DETAILS_REQUEST';
export const PROCESSING_JOB_DETAILS_SUCCESS = 'PROCESSING_JOB_DETAILS_SUCCESS';
export const PROCESSING_JOB_DETAILS_FAIL = 'PROCESSING_JOB_DETAILS_FAIL';
export const PROCESSING_JOB_DETAILS_RESET = 'PROCESSING_JOB_DETAILS_RESET';

export const PROCESSING_JOB_CREATE_REQUEST = 'PROCESSING_JOB_CREATE_REQUEST';
export const PROCESSING_JOB_CREATE_SUCCESS = 'PROCESSING_JOB_CREATE_SUCCESS';
export const PROCESSING_JOB_CREATE_FAIL = 'PROCESSING_JOB_CREATE_FAIL';
export const PROCESSING_JOB_CREATE_RESET = 'PROCESSING_JOB_CREATE_RESET';

export const PROCESSING_JOB_UPDATE_REQUEST = 'PROCESSING_JOB_UPDATE_REQUEST';
export const PROCESSING_JOB_UPDATE_SUCCESS = 'PROCESSING_JOB_UPDATE_SUCCESS';
export const PROCESSING_JOB_UPDATE_FAIL = 'PROCESSING_JOB_UPDATE_FAIL';
export const PROCESSING_JOB_UPDATE_RESET = 'PROCESSING_JOB_UPDATE_RESET';

export const PROCESSING_JOB_DELETE_REQUEST = 'PROCESSING_JOB_DELETE_REQUEST';
export const PROCESSING_JOB_DELETE_SUCCESS = 'PROCESSING_JOB_DELETE_SUCCESS';
export const PROCESSING_JOB_DELETE_FAIL = 'PROCESSING_JOB_DELETE_FAIL';

export const PROCESSING_JOB_DTO_REQUEST = 'PROCESSING_JOB_DTO_REQUEST';
export const PROCESSING_JOB_DTO_SUCCESS = 'PROCESSING_JOB_DTO_SUCCESS';
export const PROCESSING_JOB_DTO_FAIL = 'PROCESSING_JOB_DTO_FAIL';
export const PROCESSING_JOB_DTO_RESET = 'PROCESSING_JOB_DTO_RESET';

// Custom action constants for ProcessingJob specific functionality
export const PROCESSING_JOB_BY_UPLOAD_BATCH_REQUEST = 'PROCESSING_JOB_BY_UPLOAD_BATCH_REQUEST';
export const PROCESSING_JOB_BY_UPLOAD_BATCH_SUCCESS = 'PROCESSING_JOB_BY_UPLOAD_BATCH_SUCCESS';
export const PROCESSING_JOB_BY_UPLOAD_BATCH_FAIL = 'PROCESSING_JOB_BY_UPLOAD_BATCH_FAIL';
export const PROCESSING_JOB_BY_UPLOAD_BATCH_RESET = 'PROCESSING_JOB_BY_UPLOAD_BATCH_RESET';

export const PROCESSING_JOB_BY_STATUS_REQUEST = 'PROCESSING_JOB_BY_STATUS_REQUEST';
export const PROCESSING_JOB_BY_STATUS_SUCCESS = 'PROCESSING_JOB_BY_STATUS_SUCCESS';
export const PROCESSING_JOB_BY_STATUS_FAIL = 'PROCESSING_JOB_BY_STATUS_FAIL';

export const PROCESSING_JOB_BY_JOB_TYPE_REQUEST = 'PROCESSING_JOB_BY_JOB_TYPE_REQUEST';
export const PROCESSING_JOB_BY_JOB_TYPE_SUCCESS = 'PROCESSING_JOB_BY_JOB_TYPE_SUCCESS';
export const PROCESSING_JOB_BY_JOB_TYPE_FAIL = 'PROCESSING_JOB_BY_JOB_TYPE_FAIL'; 